const BASE = `${process.env.REACT_APP_STRAPI_APP_URL}/api`;
const READONLY_API_TOKEN = process.env.REACT_APP_Strapi_READONLY_TOKEN;
export async function sendContactMessage(
  data: {
    name: string;
    email: string;
    phoneNumber: string;
    companyName: string;
    reasonOfContacting: string;
    whatLookingFor: string;
  },
): Promise<void> {
  await fetch(`${BASE}/contact/send`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${READONLY_API_TOKEN}`,
    },
    body: JSON.stringify(data),
  });
}

export async function sendSubscriptionRequest(
  email: string
): Promise<void> {
  await fetch(`${BASE}/contact/subscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${READONLY_API_TOKEN}`,
    },
    body: JSON.stringify({email}),
  });
}
